import { ImageResource } from '@owl-nest/api-client/latest'

export function getUrl(versions: ImageResource['versions'], version: string): string | undefined {
  return versions?.[version]?.url
}
